import React from "react";

function About_banner() {
  return (
    <div
      id="about_banner"
      className="about-banner relative h-[500px] w-full px-20 max-[500px]:px-10 pb-10 overflow-hidden"
    >
      <div className="absolute inset-0 bg-black/60"></div>
      <div className="relative z-10 pt-24 text-white">
        <p className="text-sm md:text-lg tracking-[4px] text-blue-400 font-semibold uppercase mb-6">
          Enterprise Product Portfolio
        </p>
        <div className="w-2/3 max-[950px]:w-full">
          <h1 className="text-5xl max-[950px]:text-4xl max-[500px]:text-2xl font-bold leading-tight drop-shadow-2xl">
            Focused software platforms for security, operations, and business
            management.
          </h1>
        </div>
        <div className="w-3/4 max-[950px]:w-full mt-8">
          <p className="text-lg max-[500px]:text-base text-gray-200 leading-relaxed">
            Explore MapleCloud’s enterprise software portfolio across AI-powered
            security operations, monitoring, zero trust access, enterprise
            management, IT operations, and SaaS business workflows.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About_banner;
